import React from "react"
import { Grid, Typography} from "@material-ui/core"
import SkywatchInformationTooltip from "../../../Core/Popover/SkywatchInformationTooltip";
// import { ControlledCheckBox } from "../../../Core/Form/ControlledFields";
import AirportAuthorityTextArea from "./AirportAuthorityTextArea";
import DesktopOnlyText from '../../../Core/Text/DesktopOnlyText';
import { ControlledCheckBox } from "../../../Core/Form/CheckBox";

const MedicalSection = (medicalLimit) => {
    return (
    <Grid container md={12}>
        <Grid container justifyContent="space-between" alignItems="center" className="margin-bottom-small">
            <Grid item>
                <SkywatchInformationTooltip subtext="Insurance coverage that applies to reasonable medical expenses incurred within one year from the date of injury" text="Medical Expense coverage is designed to pay reasonable medical expenses incurred within one year from the date of injury, to or for each passenger who sustains bodily caused by an occurrence covered by this insurance. You are not required to be found legally liable for these payments to be available. The medical Expense Limit is available to you, the policyholder, as well. The Medical Expense Limit is in addition to the Liability Insurance limits." placement="right">
                    {medicalLimit.medicalLimit!=null &&<Typography variant="h3" className="blue">Medical expense included:  ${medicalLimit.medicalLimit.toLocaleString("en-US")}</Typography>}
                </SkywatchInformationTooltip>
                <DesktopOnlyText variant="body1" className="margin-top-6">Insurance coverage that applies to reasonable medical expenses incurred within<br />one year from the date of injury</DesktopOnlyText>
            </Grid>
        </Grid>
        <Grid container justifyContent="space-between" alignItems="center" className="margin-bottom-small">
            <Grid item xs={12}>
                <SkywatchInformationTooltip text="There is no additional  premium to include your home base airport authority as an Additional Insured." placement="right">
                    <ControlledCheckBox name="add_airport_authority" label="Add governmental airport authority as an additional insured"/>
                </SkywatchInformationTooltip>
            </Grid>
        </Grid>
        <AirportAuthorityTextArea />
    </Grid>
    )
}

export default MedicalSection;